var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "atlas-container", attrs: { id: "atlas-block" } },
    [
      _c("Logo", {
        attrs: {
          show_custom: true,
          custom_logo: _vm.custom_logo,
          color: "Blue",
          cwa_logo_src:
            "/static/UIUX/images/header/" +
            _vm.logo_file_name +
            "_Blue_web@3x.png"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "atlas" }, [
        _c(
          "div",
          { staticClass: "atlas-table-page", attrs: { id: "atlas-wra" } },
          [
            _c(
              "div",
              { staticClass: "atlas-table-page__container" },
              _vm._l(_vm.current_template, function(data, template_index) {
                return _c(
                  "div",
                  { key: "template_" + data.tag + "_" + template_index },
                  [
                    data.tag === "title"
                      ? [
                          _c("div", { staticClass: "atlas__title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.text) +
                                "\n                        "
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "subtitle"
                      ? [
                          _c("AtlasIntroduction", {
                            attrs: {
                              titles: data.titles,
                              en_title: data.title_en,
                              update_messages: data.update_messages
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "datetime-select"
                      ? [
                          _c("AtlasDatetimeSelect", {
                            attrs: {
                              default_value: _vm.image_type,
                              timestamp: _vm.current_timestamp
                            },
                            on: { update_timestamp: _vm.update_timestamp }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "date-table"
                      ? [
                          _c("AtlasTableDate", {
                            key:
                              _vm.current_date.name +
                              "_" +
                              data.tag +
                              "_" +
                              template_index,
                            staticClass: "table-date",
                            class: data.data_class,
                            attrs: {
                              id: "table-date-" + template_index,
                              row_date_count: data.row_date_count,
                              column_date_count: data.column_date_count,
                              images_dir: data.images_dir,
                              file_name: data.file_name,
                              compression: data.compression
                            },
                            on: { "open-image-dialog": _vm.open_image_dialog }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "date-single-table"
                      ? [
                          _c("AtlasSingleTableDate", {
                            key:
                              _vm.current_date.name +
                              "_" +
                              data.tag +
                              "_" +
                              template_index,
                            staticClass: "table-date",
                            class: data.data_class,
                            attrs: {
                              id: "table-date-" + template_index,
                              row_date_count: data.row_date_count,
                              column_date_count: data.column_date_count,
                              images_dir: data.images_dir,
                              file_name: data.file_name,
                              compression: data.compression
                            },
                            on: { "open-image-dialog": _vm.open_image_dialog }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "grid"
                      ? [
                          data.images.length
                            ? _c(
                                "div",
                                {
                                  key: "current_ts_" + _vm.current_timestamp,
                                  staticClass: "atlas-grid__divide",
                                  style:
                                    "grid-template-columns: repeat(" +
                                    data.grid +
                                    ", 1fr);"
                                },
                                _vm._l(data.images, function(
                                  image,
                                  image_index
                                ) {
                                  return _c("AtlasGrid", {
                                    key:
                                      _vm.current_date.name +
                                      "_" +
                                      data.tag +
                                      "_" +
                                      template_index +
                                      "_" +
                                      image_index,
                                    class: { center: image.center },
                                    attrs: { image: image },
                                    on: {
                                      "open-image-dialog": _vm.open_image_dialog
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "grid-bind"
                      ? [
                          data.images.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "atlas-grid__divide",
                                  style:
                                    "grid-template-columns: repeat(" +
                                    data.images.length +
                                    ", 1fr);"
                                },
                                _vm._l(data.images, function(
                                  data_images,
                                  data_images_index
                                ) {
                                  return _c(
                                    "div",
                                    { key: "bind_" + data_images_index },
                                    _vm._l(data_images, function(
                                      image,
                                      image_index
                                    ) {
                                      return _c("AtlasGrid", {
                                        key: image.src,
                                        attrs: { image: image },
                                        on: {
                                          "open-image-dialog":
                                            _vm.open_image_dialog
                                        }
                                      })
                                    }),
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "annotation"
                      ? [
                          _c(
                            "div",
                            {
                              class: {
                                "atlas-grid__left-right": data.left_right
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "atlas__annotation" },
                                [
                                  data.hide
                                    ? [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "atlas__annotation__btn",
                                            on: {
                                              click: function($event) {
                                                _vm.is_show_annotation[
                                                  template_index
                                                ] = !_vm.is_show_annotation[
                                                  template_index
                                                ]
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(data.text) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        data.list
                                          ? [
                                              _c(
                                                "ol",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.is_show_annotation[
                                                          template_index
                                                        ],
                                                      expression:
                                                        "is_show_annotation[template_index]"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "atlas__annotation__content",
                                                  class: {
                                                    "atlas__annotation__content--visible":
                                                      _vm.is_show_annotation[
                                                        template_index
                                                      ]
                                                  }
                                                },
                                                _vm._l(data.list, function(
                                                  text,
                                                  text_index
                                                ) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key:
                                                        "list_text_" +
                                                        text_index
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(text) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        data.image
                                          ? [
                                              _c("img", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.is_show_annotation[
                                                        template_index
                                                      ],
                                                    expression:
                                                      "is_show_annotation[template_index]"
                                                  }
                                                ],
                                                staticClass:
                                                  "atlas__annotation",
                                                attrs: {
                                                  alt: data.image.alt,
                                                  src: data.image.src,
                                                  width:
                                                    "" + (data.width || "100%"),
                                                  height: "100%"
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(data.text) +
                                            "\n                                    "
                                        ),
                                        data.image
                                          ? [
                                              _c("img", {
                                                attrs: {
                                                  alt: data.image.alt,
                                                  src: data.image.src,
                                                  width:
                                                    "" + (data.width || "100%"),
                                                  height: "100%"
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "note"
                      ? [
                          _c("div", { staticClass: "atlas__note" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(data.text) +
                                "\n                        "
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "link"
                      ? [
                          _c("div", { staticClass: "atlas-link" }, [
                            _c(
                              "a",
                              {
                                staticClass: "atlas-link__link",
                                attrs: { href: data.href, target: "_blank" }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(data.text) +
                                    "\n                                "
                                ),
                                _c("v-icon", [_vm._v("mdi-launch")])
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "title-left-right"
                      ? [
                          _c("div", { staticClass: "atlas-grid__left-right" }, [
                            _c("div", { staticClass: "atlas__title" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(data.text_left) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "atlas__title" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(data.text_right) +
                                  "\n                            "
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "subtitle-left-right"
                      ? [
                          _c(
                            "div",
                            { staticClass: "atlas-grid__left-right" },
                            [
                              _c("AtlasIntroduction", {
                                attrs: {
                                  titles: data.titles_left,
                                  en_title: data.title_en_left,
                                  update_messages: data.update_messages_left
                                }
                              }),
                              _vm._v(" "),
                              _c("AtlasIntroduction", {
                                attrs: {
                                  titles: data.titles_right,
                                  en_title: data.title_en_right,
                                  update_messages: data.update_messages_right
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "header-fill"
                      ? [
                          _c("div", { staticClass: "atlas-grid__left-right" }, [
                            _c(
                              "div",
                              { staticClass: "atlas-grid__table-header-fill" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(data.text) +
                                    "\n                            "
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "grid-left-right"
                      ? [
                          _c("div", { staticClass: "atlas-grid__left-right" }, [
                            _c(
                              "div",
                              _vm._l(data.images_left, function(
                                image,
                                image_index
                              ) {
                                return _c("AtlasGrid", {
                                  key:
                                    _vm.current_date.name +
                                    "_" +
                                    data.tag +
                                    "_" +
                                    template_index +
                                    "_left" +
                                    image_index,
                                  attrs: { image: image },
                                  on: {
                                    "open-image-dialog": _vm.open_image_dialog
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(data.images_right, function(
                                image,
                                image_index
                              ) {
                                return _c("AtlasGrid", {
                                  key:
                                    _vm.current_date.name +
                                    "_" +
                                    data.tag +
                                    "_" +
                                    template_index +
                                    "_right" +
                                    image_index,
                                  attrs: { image: image },
                                  on: {
                                    "open-image-dialog": _vm.open_image_dialog
                                  }
                                })
                              }),
                              1
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "multiple-chart"
                      ? [
                          _c("MultipleChart", {
                            attrs: {
                              zone_span: data.zone_span,
                              option_local_storage_name:
                                data.option_local_storage_name
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "time-select-table"
                      ? [
                          _c("AtlasTimeSelectTable", {
                            key:
                              _vm.current_date.name +
                              "_" +
                              data.tag +
                              "_" +
                              template_index,
                            class: data.data_class,
                            attrs: { current_data: data },
                            on: { "open-image-dialog": _vm.open_image_dialog }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "help-icon"
                      ? [
                          _c(
                            "div",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-icon",
                                  attrs: { fab: "", "x-small": "" },
                                  on: {
                                    click: function($event) {
                                      _vm.show_help_dialog = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("icon-help")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "btn-text" }, [
                                    _vm._v(" 說明 ")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  attrs: { width: "fit-content" },
                                  model: {
                                    value: _vm.show_help_dialog,
                                    callback: function($$v) {
                                      _vm.show_help_dialog = $$v
                                    },
                                    expression: "show_help_dialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        {
                                          staticStyle: {
                                            "background-color": "#2366f8"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { color: "white" } },
                                            [
                                              _vm._v(
                                                " \n                                            說明 \n                                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.show_help_dialog = false
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " \n                                                mdi-close \n                                            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticStyle: { "margin-top": "10px" },
                                        attrs: {
                                          alt: data.image.alt,
                                          src: data.image.src,
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "grid-padding"
                      ? [
                          data.images.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "atlas-grid__divide",
                                  style:
                                    "grid-template-columns: repeat(" +
                                    data.grid +
                                    ", 1fr); padding: 15px 10px 10px;"
                                },
                                _vm._l(data.images, function(
                                  image,
                                  image_index
                                ) {
                                  return _c("AtlasGrid", {
                                    key:
                                      _vm.current_date.name +
                                      "_" +
                                      data.tag +
                                      "_" +
                                      template_index +
                                      "_" +
                                      image_index,
                                    class: { center: image.center },
                                    attrs: { image: image },
                                    on: {
                                      "open-image-dialog": _vm.open_image_dialog
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    data.tag === "btn-area"
                      ? [
                          _c(
                            "div",
                            { staticClass: "btn-area" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-icon",
                                  attrs: { fab: "", "x-small": "" },
                                  on: {
                                    click: function($event) {
                                      _vm.show_help_dialog_2 = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("icon-help")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "btn-text" }, [
                                    _vm._v(" 說明 ")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-icon",
                                  attrs: { fab: "", "x-small": "" },
                                  on: { click: _vm.download_csv }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "#2366f8" } },
                                    [
                                      _vm._v(
                                        "\n                                    icon-file-download\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "btn-text" }, [
                                    _vm._v("下載表格CSV")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  attrs: { width: "fit-content" },
                                  model: {
                                    value: _vm.show_help_dialog_2,
                                    callback: function($$v) {
                                      _vm.show_help_dialog_2 = $$v
                                    },
                                    expression: "show_help_dialog_2"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        {
                                          staticStyle: {
                                            "background-color": "#2366f8"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { color: "white" } },
                                            [
                                              _vm._v(
                                                " \n                                            說明 \n                                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.show_help_dialog_2 = false
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " \n                                                mdi-close \n                                            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticStyle: { "margin-top": "10px" },
                                        attrs: {
                                          alt: data.image.alt,
                                          src: data.image.src,
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            height: "100%",
            "content-class": "atlas-dialog",
            fullscreen: ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "atlas-dialog__container",
              on: { click: _vm.close_atlas_dialog }
            },
            [
              _c("img", {
                attrs: { src: _vm.dialog_image_path },
                on: { click: _vm.maintain_atlas_dialog }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "atlas-dialog__close-btn",
                  attrs: { icon: "", dark: "", "x-large": "" },
                  on: { click: _vm.close_atlas_dialog }
                },
                [_c("v-icon", [_vm._v("icon-close")])],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }